import * as React from "react";
import get from "lodash/get";

import { ComponentBase, ComponentBaseProps } from "../ComponentBase";
import {
  getIsMemberTierLoading,
  getMemberTierCustomer,
} from "../../reducers/methods";

export interface MemberTierProps extends ComponentBaseProps {
  action: string;
  center: string;
  classNames: string;
  label: string;
  memberTierCustomer: ReturnType<typeof getMemberTierCustomer>;
  memberTierCustomText?: string;
  isLoading: ReturnType<typeof getIsMemberTierLoading>;
  onClick: () => void;
  style: { [styleProp: string]: string };
}

export class MemberTier extends ComponentBase<MemberTierProps> {
  render() {
    const {
      classNames,
      data,
      label = "member_tier",
      isEditing,
      isLoading,
      memberTierCustomer,
      memberTierCustomText,
    } = this.props;
    const isCustomerAuthenticated = get(data, "customer.authenticated", false);
    if (!isCustomerAuthenticated && !isEditing) {
      return null;
    }
    const tierNameCached = get(memberTierCustomer, "memberTierNameCached");
    const shouldDisplay = isEditing || isLoading || tierNameCached;

    return (
      <div
        id={this.props.configName}
        onDragStart={this.onDragStart}
        onAnimationEnd={this.resetAnimation}
        style={{
          ...this.props.style,
          display: shouldDisplay ? "initial" : "none",
        }}
        className={`MemberTier-container  ${classNames || ""} ${
          this.state.animationClass
        }`}
        aria-label={label}
        ref={(component) => (this.component = component)}
      >
        {memberTierCustomText}
        {isEditing ? "BRONZE TIER" : tierNameCached}
      </div>
    );
  }
}
